import './utils/polyfills';
import { initErrorReporter } from './utils/errorReporter';

initErrorReporter();
